import styled, { css } from 'styled-components';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
export const InputStyles = css `
  display: block;
  box-sizing: border-box;
  padding: ${pxToRems(12)};
  width: 100%;
  line-height: ${pxToRems(24)};
  margin: ${pxToRems(8)} 0;
  border: 1px solid #999999;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.ColorWhiteOpacity100};
  color: ${({ theme }) => theme.ColorGrey900};

  ${({ icon, iconPosition }) => icon &&
    css `
      padding-left: ${iconPosition === 'left' ? pxToRems(48) : 'auto'};
      padding-right: ${iconPosition === 'right' ? pxToRems(48) : 'auto'};

      @media screen and (min-width: ${breakpoints[0]}px) {
        padding-left: ${iconPosition === 'left' ? pxToRems(44) : 'auto'};
        padding-right: ${iconPosition === 'right' ? pxToRems(44) : 'auto'};
      }
    `}

  &::placeholder {
    color: ${({ theme }) => theme.ColorGrey400};
  }

  &:hover,
  &:focus {
    border-color: #666666;
  }

  &:focus {
    border-color: ${({ theme }) => theme.ColorInputActiveHoverOutline};
    outline: 1px solid ${({ theme }) => theme.ColorInputActiveHoverOutline};
    &::placeholder {
      color: ${({ theme }) => theme.ColorGrey200};
    }
  }

  ${({ type }) => type === 'browse' &&
    css `
      cursor: pointer;
    `}

  ${({ disabled, isDisabled, isReadOnly, readOnly, type }) => (disabled || isDisabled || readOnly || isReadOnly) &&
    type !== 'browse' &&
    css `
      background-color: #f1f1f1;
      cursor: not-allowed;
    `}

  ${({ status, theme }) => {
    if (status === 'error') {
        return css `
        border-color: ${theme.ColorStatusAttention500};
        border-width: 2px;
        &:hover,
        &:focus {
          border-color: ${theme.ColorStatusAttention600};
        }
      `;
    }
    if (status === 'valid') {
        return css `
        border-color: ${theme.ColorStatusConstructive400};
        &:hover,
        &:focus {
          border-color: ${theme.ColorStatusConstructive600};
        }
      `;
    }
}}
`;
export const StyledContainer = styled.div `
  position: relative;
`;
export const StyledIconContainer = styled.div.attrs({ role: 'presentation' }) `
  right: ${({ iconPosition }) => (iconPosition === 'right' ? 0 : 'auto')};
  left: ${({ iconPosition }) => (iconPosition === 'left' ? 0 : 'auto')};
  position: absolute;
  width: ${pxToRems(48)};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: ${breakpoints[0]}px) {
    width: ${pxToRems(44)};
  }
`;
export const InputStyled = styled.input `
  ${InputStyles}
`;
//# sourceMappingURL=input.styles.js.map